//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UserClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetUserListUserQueryParameters = {
  name?: string | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type CreateUsersFromExcelUserMutationParameters = {
  file?: Types.FileParameter | null | undefined ;
  sendEmails?: boolean | undefined ;
}

export type SendNewWelcomeEmailsByRoleUserQueryParameters = {
  role?: string | undefined ;
}

export type SendNewWelcomeEmailWithNewPasswordUserQueryParameters = {
  emailOrLogin?: string | undefined ;
}


export type UpdateUserInformationUserQueryParameters = {
  userId: string ;
}

export type DeleteUserUserQueryParameters = {
  userId: string ;
}

export type SendResetPasswordEmailUserQueryParameters = {
  email?: string | undefined ;
}

export type ResetPasswordUserQueryParameters = {
  username?: string | undefined ;
  token?: string | undefined ;
  newPassword?: string | undefined ;
}

export function getUserListUrl(name?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/users?";
if (name === null)
    throw new Error("The parameter 'name' cannot be null.");
else if (name !== undefined)
    url_ += "Name=" + encodeURIComponent("" + name) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getUserListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfUserListItemDto, unknown, Types.PagedResultOfUserListItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfUserListItemDto, unknown, Types.PagedResultOfUserListItemDto>, 'queryFn'>> = {
};
export function getGetUserListDefaultOptions() {
  return getUserListDefaultOptions;
};
export function setGetUserListDefaultOptions(options: typeof getUserListDefaultOptions) {
  getUserListDefaultOptions = options;
}

export function getUserListQueryKey(dto: GetUserListUserQueryParameters): QueryKey;
export function getUserListQueryKey(name?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getUserListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { name, offset, limit, sortBy, sortOrder,  } = params[0] as GetUserListUserQueryParameters;

    return trimArrayEnd([
        'UserClient',
        'getUserList',
        name as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserClient',
        'getUserList',
        ...params
      ]);
  }
}
export function __getUserList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getUserList(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetUserListQuery<TSelectData = Types.PagedResultOfUserListItemDto, TError = unknown>(dto: GetUserListUserQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfUserListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get User List.
 * @param name (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetUserListQuery<TSelectData = Types.PagedResultOfUserListItemDto, TError = unknown>(name?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfUserListItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetUserListQuery<TSelectData = Types.PagedResultOfUserListItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfUserListItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let name: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ name, offset, limit, sortBy, sortOrder,  } = params[0] as GetUserListUserQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [name, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfUserListItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getUserList(context, axiosConfig) : __getUserList,
    queryKey: getUserListQueryKey(name, offset, limit, sortBy, sortOrder),
    ...getUserListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfUserListItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get User List.
 * @param name (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetUserListData(queryClient: QueryClient, updater: (data: Types.PagedResultOfUserListItemDto | undefined) => Types.PagedResultOfUserListItemDto, name?: string | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getUserListQueryKey(name, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Get User List.
 * @param name (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetUserListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfUserListItemDto | undefined) => Types.PagedResultOfUserListItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUsersFromExcelUrl(): string {
  let url_ = getBaseUrl() + "/api/users/create-from-file";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createUsersFromExcelMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'createUsersFromExcel',
    ]);
}

/**
 * Column A for User Name,
Column B for Customer Number,
Column C for RealName,
Column D for Email,
Column E for Country Code,
Column F for Role.
Data started from second Row.
First Row for column name.
 * @param file (optional) 
 * @param sendEmails (optional) 
 */
export function useCreateUsersFromExcelMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, CreateUsersFromExcelUserMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, CreateUsersFromExcelUserMutationParameters, TContext> {
  const key = createUsersFromExcelMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createUsersFromExcelUserMutationParameters: CreateUsersFromExcelUserMutationParameters) => Client.createUsersFromExcel(createUsersFromExcelUserMutationParameters.file, createUsersFromExcelUserMutationParameters.sendEmails),
    mutationKey: key,
  });
}
  
export function sendNewWelcomeEmailsByRoleUrl(role?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/users/resend-welcome-emails-by-role?";
if (role === null)
    throw new Error("The parameter 'role' cannot be null.");
else if (role !== undefined)
    url_ += "role=" + encodeURIComponent("" + role) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendNewWelcomeEmailsByRoleMutationKey(role?: string | undefined): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'sendNewWelcomeEmailsByRole',
      role as any,
    ]);
}

/**
 * Send New Welcome Emails By Role.
 * @param role (optional) 
 */
export function useSendNewWelcomeEmailsByRoleMutation<TContext>(role?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sendNewWelcomeEmailsByRoleMutationKey(role);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sendNewWelcomeEmailsByRole(role),
    mutationKey: key,
  });
}
  
type SendNewWelcomeEmailsByRole__MutationParameters = SendNewWelcomeEmailsByRoleUserQueryParameters

/**
 * Send New Welcome Emails By Role.
 * @param role (optional) 
 */
export function useSendNewWelcomeEmailsByRoleMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendNewWelcomeEmailsByRole__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendNewWelcomeEmailsByRoleUserQueryParameters}): UseMutationResult<void, unknown, SendNewWelcomeEmailsByRole__MutationParameters, TContext> {
  const key = sendNewWelcomeEmailsByRoleMutationKey(options?.parameters?.role!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendNewWelcomeEmailsByRole__MutationParameters) => Client.sendNewWelcomeEmailsByRole(data.role ?? options?.parameters?.role!),
  mutationKey: key,
});
}
  
export function sendNewWelcomeEmailWithNewPasswordUrl(emailOrLogin?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/users/resend-welcome-email?";
if (emailOrLogin === null)
    throw new Error("The parameter 'emailOrLogin' cannot be null.");
else if (emailOrLogin !== undefined)
    url_ += "EmailOrLogin=" + encodeURIComponent("" + emailOrLogin) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendNewWelcomeEmailWithNewPasswordMutationKey(emailOrLogin?: string | undefined): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'sendNewWelcomeEmailWithNewPassword',
      emailOrLogin as any,
    ]);
}

/**
 * Send New Welcome Email With New Password.
 * @param emailOrLogin (optional) 
 */
export function useSendNewWelcomeEmailWithNewPasswordMutation<TContext>(emailOrLogin?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sendNewWelcomeEmailWithNewPasswordMutationKey(emailOrLogin);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sendNewWelcomeEmailWithNewPassword(emailOrLogin),
    mutationKey: key,
  });
}
  
type SendNewWelcomeEmailWithNewPassword__MutationParameters = SendNewWelcomeEmailWithNewPasswordUserQueryParameters

/**
 * Send New Welcome Email With New Password.
 * @param emailOrLogin (optional) 
 */
export function useSendNewWelcomeEmailWithNewPasswordMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendNewWelcomeEmailWithNewPassword__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendNewWelcomeEmailWithNewPasswordUserQueryParameters}): UseMutationResult<void, unknown, SendNewWelcomeEmailWithNewPassword__MutationParameters, TContext> {
  const key = sendNewWelcomeEmailWithNewPasswordMutationKey(options?.parameters?.emailOrLogin!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendNewWelcomeEmailWithNewPassword__MutationParameters) => Client.sendNewWelcomeEmailWithNewPassword(data.emailOrLogin ?? options?.parameters?.emailOrLogin!),
  mutationKey: key,
});
}
  
export function createNewUserUrl(): string {
  let url_ = getBaseUrl() + "/api/users/create";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createNewUserMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'createNewUser',
    ]);
}

/**
 * Create New User.
 */
export function useCreateNewUserMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.CreateNewUserRequestDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.CreateNewUserRequestDto, TContext> {
  const key = createNewUserMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (request: Types.CreateNewUserRequestDto) => Client.createNewUser(request),
    mutationKey: key,
  });
}
  
export function getCurrentUserInfoUrl(): string {
  let url_ = getBaseUrl() + "/api/users/me";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCurrentUserInfoDefaultOptions: Omit<UseQueryOptions<Types.UserEnumRolesDto, unknown, Types.UserEnumRolesDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.UserEnumRolesDto, unknown, Types.UserEnumRolesDto>, 'queryFn'>> = {
};
export function getGetCurrentUserInfoDefaultOptions() {
  return getCurrentUserInfoDefaultOptions;
};
export function setGetCurrentUserInfoDefaultOptions(options: typeof getCurrentUserInfoDefaultOptions) {
  getCurrentUserInfoDefaultOptions = options;
}

export function getCurrentUserInfoQueryKey(): QueryKey;
export function getCurrentUserInfoQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UserClient',
      'getCurrentUserInfo',
    ]);
}
export function __getCurrentUserInfo(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCurrentUserInfo(
axiosConfig    );
}

/**
 * Get Current User Info.
 */
export function useGetCurrentUserInfoQuery<TSelectData = Types.UserEnumRolesDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.UserEnumRolesDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCurrentUserInfoQuery<TSelectData = Types.UserEnumRolesDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UserEnumRolesDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.UserEnumRolesDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCurrentUserInfo(context, axiosConfig) : __getCurrentUserInfo,
    queryKey: getCurrentUserInfoQueryKey(),
    ...getCurrentUserInfoDefaultOptions as unknown as Omit<UseQueryOptions<Types.UserEnumRolesDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get Current User Info.
 */
export function setGetCurrentUserInfoData(queryClient: QueryClient, updater: (data: Types.UserEnumRolesDto | undefined) => Types.UserEnumRolesDto, ) {
  queryClient.setQueryData(getCurrentUserInfoQueryKey(),
    updater
  );
}

/**
 * Get Current User Info.
 */
export function setGetCurrentUserInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UserEnumRolesDto | undefined) => Types.UserEnumRolesDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function updateCurrentUserInfoUrl(): string {
  let url_ = getBaseUrl() + "/api/users/me";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateCurrentUserInfoMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'updateCurrentUserInfo',
    ]);
}

/**
 * Update Current User Info.
 */
export function useUpdateCurrentUserInfoMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.UpdateCurrentUserInfoDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateCurrentUserInfoDto, TContext> {
  const key = updateCurrentUserInfoMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateCurrentUserInfoDto) => Client.updateCurrentUserInfo(dto),
    mutationKey: key,
  });
}
  
export function updateUserInformationUrl(userId: string): string {
  let url_ = getBaseUrl() + "/api/users/{userId}";
if (userId === undefined || userId === null)
  throw new Error("The parameter 'userId' must be defined.");
url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateUserInformationMutationKey(userId: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'updateUserInformation',
      userId as any,
    ]);
}

/**
 * Update User Information.
 */
export function useUpdateUserInformationMutation<TContext>(userId: string, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateUserDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateUserDto, TContext> {
  const key = updateUserInformationMutationKey(userId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateUserDto) => Client.updateUserInformation(userId, dto),
    mutationKey: key,
  });
}
  
type UpdateUserInformation__MutationParameters = UpdateUserInformationUserQueryParameters & {
  dto: Types.UpdateUserDto;
}

/**
 * Update User Information.
 */
export function useUpdateUserInformationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, UpdateUserInformation__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UpdateUserInformationUserQueryParameters}): UseMutationResult<void, unknown, UpdateUserInformation__MutationParameters, TContext> {
  const key = updateUserInformationMutationKey(options?.parameters?.userId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: UpdateUserInformation__MutationParameters) => Client.updateUserInformation(data.userId ?? options?.parameters?.userId!, data.dto),
  mutationKey: key,
});
}
  
export function deleteUserUrl(userId: string): string {
  let url_ = getBaseUrl() + "/api/users/{userId}";
if (userId === undefined || userId === null)
  throw new Error("The parameter 'userId' must be defined.");
url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deleteUserMutationKey(userId: string): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'deleteUser',
      userId as any,
    ]);
}

/**
 * Deletes user.
 */
export function useDeleteUserMutation<TContext>(userId: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deleteUserMutationKey(userId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.deleteUser(userId),
    mutationKey: key,
  });
}
  
type DeleteUser__MutationParameters = DeleteUserUserQueryParameters

/**
 * Deletes user.
 */
export function useDeleteUserMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DeleteUser__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DeleteUserUserQueryParameters}): UseMutationResult<void, unknown, DeleteUser__MutationParameters, TContext> {
  const key = deleteUserMutationKey(options?.parameters?.userId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DeleteUser__MutationParameters) => Client.deleteUser(data.userId ?? options?.parameters?.userId!),
  mutationKey: key,
});
}
  
export function changePasswordUrl(): string {
  let url_ = getBaseUrl() + "/api/users/change-password";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function changePasswordMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'changePassword',
    ]);
}

/**
 * Changes password.
 */
export function useChangePasswordMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.ChangePasswordDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.ChangePasswordDto, TContext> {
  const key = changePasswordMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ChangePasswordDto) => Client.changePassword(dto),
    mutationKey: key,
  });
}
  
export function sendResetPasswordEmailUrl(email?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/users/send-reset-password?";
if (email === null)
    throw new Error("The parameter 'email' cannot be null.");
else if (email !== undefined)
    url_ += "email=" + encodeURIComponent("" + email) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function sendResetPasswordEmailMutationKey(email?: string | undefined): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'sendResetPasswordEmail',
      email as any,
    ]);
}

/**
 * Send Reset Password Email.
 * @param email (optional) 
 */
export function useSendResetPasswordEmailMutation<TContext>(email?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = sendResetPasswordEmailMutationKey(email);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.sendResetPasswordEmail(email),
    mutationKey: key,
  });
}
  
type SendResetPasswordEmail__MutationParameters = SendResetPasswordEmailUserQueryParameters

/**
 * Send Reset Password Email.
 * @param email (optional) 
 */
export function useSendResetPasswordEmailMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, SendResetPasswordEmail__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: SendResetPasswordEmailUserQueryParameters}): UseMutationResult<void, unknown, SendResetPasswordEmail__MutationParameters, TContext> {
  const key = sendResetPasswordEmailMutationKey(options?.parameters?.email!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: SendResetPasswordEmail__MutationParameters) => Client.sendResetPasswordEmail(data.email ?? options?.parameters?.email!),
  mutationKey: key,
});
}
  
export function resetPasswordUrl(username?: string | undefined, token?: string | undefined, newPassword?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/users/reset-password?";
if (username === null)
    throw new Error("The parameter 'username' cannot be null.");
else if (username !== undefined)
    url_ += "Username=" + encodeURIComponent("" + username) + "&";
if (token === null)
    throw new Error("The parameter 'token' cannot be null.");
else if (token !== undefined)
    url_ += "Token=" + encodeURIComponent("" + token) + "&";
if (newPassword === null)
    throw new Error("The parameter 'newPassword' cannot be null.");
else if (newPassword !== undefined)
    url_ += "NewPassword=" + encodeURIComponent("" + newPassword) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function resetPasswordMutationKey(username?: string | undefined, token?: string | undefined, newPassword?: string | undefined): MutationKey {
  return trimArrayEnd([
      'UserClient',
      'resetPassword',
      username as any,
      token as any,
      newPassword as any,
    ]);
}

/**
 * Resets password.
 * @param username (optional) 
 * @param token (optional) 
 * @param newPassword (optional) 
 */
export function useResetPasswordMutation<TContext>(username?: string | undefined, token?: string | undefined, newPassword?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = resetPasswordMutationKey(username, token, newPassword);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.resetPassword(username, token, newPassword),
    mutationKey: key,
  });
}
  
type ResetPassword__MutationParameters = ResetPasswordUserQueryParameters

/**
 * Resets password.
 * @param username (optional) 
 * @param token (optional) 
 * @param newPassword (optional) 
 */
export function useResetPasswordMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ResetPassword__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ResetPasswordUserQueryParameters}): UseMutationResult<void, unknown, ResetPassword__MutationParameters, TContext> {
  const key = resetPasswordMutationKey(options?.parameters?.username!, options?.parameters?.token!, options?.parameters?.newPassword!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ResetPassword__MutationParameters) => Client.resetPassword(data.username ?? options?.parameters?.username!, data.token ?? options?.parameters?.token!, data.newPassword ?? options?.parameters?.newPassword!),
  mutationKey: key,
});
}